module.exports = __webpack_public_path__ + "static/img/img9.5276935.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img9.png
// module id = FM3o
// module chunks = 5